import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

/**
 * FOUND-09 — runtime Zod validation of Vite-injected env.
 *
 * Module-load side effect: createEnv() throws on any validation failure
 * BEFORE React mounts, so a misconfigured VITE_API_BASE_URL is caught
 * at boot instead of surfacing as an opaque network error later.
 *
 * Variables are read from import.meta.env (Vite client env). Only
 * VITE_-prefixed vars are exposed — Vite never leaks server-side env
 * into the client bundle, so server leaks would surface at build time
 * (not here).
 */
export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_USE_MSW: z.enum(["true", "false"]).default("false"),
    // Opt-in gate for the in-app assistant surface. Committed default is OFF
    // everywhere; only the literal string "true" turns it on — any other value
    // (or absence) resolves to false.
    VITE_ASSISTANT_ENABLED: z
      .string()
      .optional()
      .transform((value) => value === "true"),
    VITE_DEV_TENANT_SLUG: z.string().min(1).default("acme"),
    VITE_API_BASE_URL: z.string().url(),
    VITE_SENTRY_DSN: z.string().optional(),
    // Google sign-in web client id. Absent → no "Continue with Google" button.
    VITE_GOOGLE_CLIENT_ID: z.string().optional(),
    // Microsoft (Entra) application id. Absent → no "Sign in with Microsoft" button.
    VITE_MICROSOFT_CLIENT_ID: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
